import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {MsTooltipDirective} from '../../directives/tooltip/tooltip.directive';
import {Props} from 'tippy.js';

@Component({
  selector: 'ms-text',
  templateUrl: './text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MsTooltipDirective],
})
export class TextComponent {
  readonly label = input<string>();
  readonly value = input<any>();
  readonly valueTooltip = input<string>();
  readonly fieldValueClass = input('');
  readonly tooltipOptions = input<Partial<Props>>({
    placement: 'bottom',
  });
}
